// A failed generation's diagnosis for the admin panel (2026-10-26;
// server/src/ai/generation-error.js): "Generation failed at <stage>", and
// behind Details the message and the stack frames (file:line only). Also the
// stages that failed and were skipped (modelMeta.stageErrors). Pure.

// { title, lines } or null when the suggestion has nothing to show.
// generationError was a plain string before 2026-10-26: shown as the message.
export function generationFailureView(modelMeta) {
  const ge = modelMeta?.generationError
  const stageErrors = Array.isArray(modelMeta?.stageErrors) ? modelMeta.stageErrors : []
  if (modelMeta?.generationFailed && ge) {
    const obj = typeof ge === 'object' ? ge : { message: String(ge), stage: null, stack: [] }
    return {
      title: `Generation failed at ${obj.stage ?? 'an unknown stage'}`,
      lines: [obj.message ? `Error: ${obj.message}` : null, ...(obj.stack ?? [])].filter(Boolean),
    }
  }
  if (stageErrors.length) {
    return {
      title: `Stage${stageErrors.length === 1 ? '' : 's'} skipped after a failure: ${stageErrors.map((e) => e.skippedStage ?? e.stage).join(', ')}`,
      lines: stageErrors.flatMap((e) => [`${e.skippedStage ?? e.stage}: ${e.message}`, ...(e.stack ?? []).slice(0, 5)]),
    }
  }
  return null
}
